/* Tidy Towel (Oct 2026): show Judge.me reviewer names as "First L." (e.g. "Bryce Hunt" -> "Bryce H.").
   Single names and "Anonymous" stay as they are. Idempotent; a MutationObserver re-applies it when
   Judge.me renders, sorts or paginates reviews with JS. Display-only: Judge.me's stored data is unchanged. */
(function () {
  if (window.ttReviewNames) return;
  var SEL = [
    '.jdgm-rev__author',                   /* product review widget + all-reviews page */
    '.jdgm-full-rev__author',              /* full-review modal */
    '.jdgm-carousel-item__reviewer-name',  /* featured carousel */
    '.jdgm-popup-card__reviewer'           /* popup widget */
  ].join(',');
  var SUFFIX = /^(jr|sr|ii|iii|iv|v)\.?$/i;
  var INITIAL_ONLY = /^\S\.?$/;

  function format(raw) {
    var s = String(raw || '').replace(/\s+/g, ' ').trim();
    if (!s || /^anonymous$/i.test(s)) return s;
    var parts = s.split(' ');
    while (parts.length > 2 && SUFFIX.test(parts[parts.length - 1])) parts.pop();
    if (parts.length < 2) return s;
    var last = parts[parts.length - 1];
    if (INITIAL_ONLY.test(last)) return s; // already "First L." / "First L"
    var letters = last.replace(/^[^A-Za-z\u00C0-\u024F\u0370-\u03FF\u0400-\u04FF]+/, '');
    var initial = Array.from(letters || last)[0];
    if (!initial) return s;
    return parts[0] + ' ' + initial.toUpperCase() + '.';
  }

  function apply(el) {
    if (!el || el.nodeType !== 1) return;
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    if (el.getAttribute('data-tt-name') === text) return; // already processed and unchanged
    var out = format(text);
    if (out !== text) el.textContent = out;
    el.setAttribute('data-tt-name', out);
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(SEL)) apply(root);
    if (root.querySelectorAll) {
      var list = root.querySelectorAll(SEL);
      for (var i = 0; i < list.length; i++) apply(list[i]);
    }
  }

  function onMutations(records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      var t = r.target.nodeType === 1 ? r.target : r.target.parentElement;
      var host = t && t.closest ? t.closest(SEL) : null;
      if (host) apply(host);
      for (var j = 0; j < r.addedNodes.length; j++) scan(r.addedNodes[j]);
    }
  }

  window.ttReviewNames = { format: format, scan: scan };
  scan(document.documentElement);
  if ('MutationObserver' in window) {
    new MutationObserver(onMutations).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
})();
